module.exports = "<svg width=\"20\" height=\"3\" viewBox=\"0 0 20 3\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Combined Shape\n  </title>\n  <path d=\"M10 2c4.984 0 5.056-2 10-2v3H0V0c4.944 0 5.016 2 10 2z\" fill=\"#E9E5D5\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/rule.svg
// module id = 3750
// module chunks = 168707334958949